import { render, staticRenderFns } from "./edit_payroll_header.vue?vue&type=template&id=62ae24ae&scoped=true"
import script from "./edit_payroll_header.vue?vue&type=script&lang=js"
export * from "./edit_payroll_header.vue?vue&type=script&lang=js"
import style0 from "./edit_payroll_header.vue?vue&type=style&index=0&id=62ae24ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae24ae",
  null
  
)

export default component.exports